module.exports = __webpack_public_path__ + "static/img/yishixiao.f70782f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yishixiao.png
// module id = yO2R
// module chunks = 1